import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import classNames from "classnames";
import upperFirst from "lodash/upperFirst";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { commonMessages } from "../../../intl";
export function ProductListItemAttributes(_ref) {
  var _ref$alwaysShowAll = _ref.alwaysShowAll,
      alwaysShowAll = _ref$alwaysShowAll === void 0 ? false : _ref$alwaysShowAll,
      _ref$withBlockDisplay = _ref.withBlockDisplayedAttributes,
      withBlockDisplayedAttributes = _ref$withBlockDisplay === void 0 ? false : _ref$withBlockDisplay,
      attributes = _ref.attributes;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showAllAttr = _useState2[0],
      showAllAttrHandler = _useState2[1];

  var intl = useIntl();
  return React.createElement("div", {
    className: classNames("cart__list__item__details__variant-wr", {
      "cart__list__item__details__variant-wr-b-attr": withBlockDisplayedAttributes,
      show: showAllAttr || alwaysShowAll
    })
  }, React.createElement("div", {
    className: "cart__list__item__details__variant"
  }, attributes.map(function (item, itemI) {
    var attributeName = upperFirst(item.translatedName || item.name).replace("-", " ");
    var attributeValue = item.values.map(function (value) {
      return upperFirst((value.translatedName || value.name).replace(attributeName.toLowerCase(), "").replace("-", " ").trim());
    }).join(", ");

    if (attributeName === "Height" || attributeName === "Width") {
      attributeValue = "".concat(attributeValue.slice(0, attributeValue.length - 1), " cm");
    }

    return React.createElement("span", {
      key: itemI,
      className: "cart__list__item__details__variant-item"
    }, React.createElement("span", {
      className: "cart__list__item-hint"
    }, attributeName, ": "), React.createElement("span", null, attributeValue), " ");
  })), !alwaysShowAll && React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      showAllAttrHandler(!showAllAttr);
    },
    type: "button",
    className: "cart__list__item__details__variant-more"
  }, showAllAttr ? intl.formatMessage(commonMessages.less) : intl.formatMessage(commonMessages.more)));
}